//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../pages/Dashboard";
import DashboardLayout from "../layouts/DashboardLayout";
import Folders from "../pages/Folders";

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/file-manager"} element={<Dashboard />} />
        <Route path={"/folder/:id"} element={<Folders />} />
        <Route path={"/file-manager/folder/:id"} element={<Folders />} />
        <Route path="folder/*" element={<Folders />} />
        <Route path="/file-manager/folder/*" element={<Folders />} />
        <Route path={"/"} element={<Dashboard />} />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
